








import Vue, { PropType } from "vue";
import log from "loglevel";
import VcProgressBar from "@/components/ProgressBar/ProgressBar.vue";
import { mapActions } from "vuex";
import { PostCloudContractsChangePlansRevokeResponse } from "@/containers/cloudContractsChangePlans/api";

export interface CloudContractsChangePlansCancelProps {
  contractNumber: string;
  waitingTime: number;
  completeUrl: string;
  errorUrl: string;
}

export interface CloudContractsChangePlansCancelData {
  isComplete: boolean;
}

export default Vue.extend({
  name: "vc-cloud-contracts-change-plans-cancel",
  components: { VcProgressBar },
  props: {
    contractNumber: {
      type: String as PropType<
        CloudContractsChangePlansCancelProps["contractNumber"]
      >,
      default: ""
    },
    waitingTime: {
      type: Number as PropType<
        CloudContractsChangePlansCancelProps["waitingTime"]
      >,
      default: 0
    },
    completeUrl: {
      type: String as PropType<
        CloudContractsChangePlansCancelProps["completeUrl"]
      >,
      default: ""
    },
    errorUrl: {
      type: String as PropType<
        CloudContractsChangePlansCancelProps["errorUrl"]
      >,
      default: ""
    }
  },
  data(): CloudContractsChangePlansCancelData {
    return {
      isComplete: false
    };
  },
  mounted() {
    this.cancelPlanChangeReservation();
  },
  methods: {
    ...mapActions("cloudContractsChangePlans", [
      "postCloudContractsChangePlansRevoke"
    ]),
    async cancelPlanChangeReservation() {
      try {
        const res: PostCloudContractsChangePlansRevokeResponse = await this.postCloudContractsChangePlansRevoke(
          {
            contractNumber: this.contractNumber
          }
        );

        this.isComplete = true;
        if (res && res.status === "success") {
          window.location.href = this.completeUrl;
        } else if (res && res.messageType) {
          window.location.href = `${this.errorUrl}?messageType=${res.messageType}`;
        } else {
          window.location.href = this.errorUrl;
        }
      } catch (error) {
        log.error(error);
        window.location.href = this.errorUrl;
      }
    }
  }
});
